import React from "react";
import { createBrowserRouter } from "react-router-dom";

import RouteErrorBoundary from "@/components/common/RouteErrorBoundary.tsx";
import Layout from "@/components/layout/Layout.tsx";
import PublicLayout from "@/components/layout/PublicLayout.tsx";
import { Login } from "@/features/auth";
import { DataDetail, DataManagement } from "@/features/data-management";
import { Mind } from "@/features/mind";
import { PublicOpinion } from "@/features/public-opinion";
import AdminRoute from "@/routes/AdminRoute.tsx";
import AuthRoute from "@/routes/authRouter.tsx";
import { PublicRoute } from "@/routes/PublicRoute.tsx";
import { RenewRoute } from "@/routes/RenewRoute.tsx";
import { SocialEventRoute } from "@/routes/SocialEventRoute.tsx";
import { TestPageRoute } from "@/routes/TestPageRoute.tsx";
import { SettingsRoute } from "@/features/settings/router.tsx";

const Home = React.lazy(() => import("@/features/home/pages/HomePage"));
const Analysis = React.lazy(() => import("@/page/analysis/AnalysisPage"));
const DistrictAnalysis = React.lazy(
  () => import("@/page/analysis/DistrictAnalysisPage"),
);
const Detail2 = React.lazy(() => import("@/page/analysis/Detail2Page"));
const Admin = React.lazy(() => import("@/page/admin/AdminPage"));
const AdminDetail = React.lazy(() => import("@/page/admin/DetailPage"));
const Issue = React.lazy(() => import("@/page/issue/IssuePage"));
const Keyword = React.lazy(() => import("@/page/keyword/KeywordPage"));
const Contact = React.lazy(() => import("@/page/contact/ContactPage"));
const Monitoring = React.lazy(() => import("@/page/monitoring/MonitoringPage"));

const NotFound = React.lazy(() => import("@/page/not-found/NotFoundPage"));

const router = createBrowserRouter([
  {
    errorElement: <RouteErrorBoundary />,
    children: [
      {
        path: "/login",
        element: <Login />,
      },
      {
        element: <PublicLayout />,
        children: [...PublicRoute],
      },
      {
        element: (
          <AuthRoute>
            <Layout />
          </AuthRoute>
        ),
        children: [
          {
            path: "home",
            element: <Home />,
          },
          {
            path: "mind",
            element: <Mind />,
          },
          {
            path: "district-analysis",
            element: <DistrictAnalysis />,
          },
          {
            path: "topic-analysis",
            element: <Analysis />,
          },
          {
            path: "public-opinion",
            element: <PublicOpinion />,
          },
          {
            path: "detail2",
            element: <Detail2 />,
          },
          {
            path: "data-management",
            element: (
              <AdminRoute>
                <DataManagement />
              </AdminRoute>
            ),
          },
          {
            path: "data-management/:id",
            element: (
              <AdminRoute>
                <DataDetail />
              </AdminRoute>
            ),
          },
          {
            path: "admin",
            element: <Admin />,
          },
          {
            path: "admin/:id",
            element: <AdminDetail />,
          },
          {
            path: "issue",
            element: <Issue />,
          },
          {
            path: "keyword",
            element: <Keyword />,
          },
          {
            path: "monitoring",
            element: <Monitoring />,
          },
          {
            path: "contact",
            element: <Contact />,
          },
          ...SettingsRoute,
          // NEW ROUTES - 개선안 PPT 기반
          ...RenewRoute,
          ...SocialEventRoute,
          ...(import.meta.env.DEV ? TestPageRoute : []),
          {
            path: "*",
            element: <NotFound />,
          },
        ],
      },
    ],
  },
]);

export default router;
